var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"ant-cascader-menu"},_vm._l((_vm.data),function(item,index){return _c('li',{class:['ant-cascader-menu-item', ( _obj = {}, _obj[_vm.prefix+'-item-expand'] = item.children, _obj ),( _obj$1 = {}, _obj$1[_vm.prefix+'-item-disabled'] = item.disabled, _obj$1 ), ( _obj$2 = {}, _obj$2[_vm.prefix+'-item-active'] = _vm.value == index, _obj$2 )],attrs:{"title":item.label},on:{"click":function($event){$event.stopPropagation();_vm.select(index,item.disabled)}}},[_vm._v("\n        "+_vm._s(item.label)+"\n    ")])
var _obj;
var _obj$1;
var _obj$2;}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9352454","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./vb/components/cascader/menu.vue
// module id = null
// module chunks = 